import { Col, Row } from 'antd';
import { BaseButton } from 'components/UI/BaseButton';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { MachineList } from './components/MachineList';

export const MyMachines = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MY_MACHINE);
  const history = useHistory();

  const handleAddMachine = useCallback(() => {
    history.push('/claiming-process');
  }, [history]);

  return (
    <div className="my-machines">
      <div className="page-header">
        <Row>
          <Col xs={24} md={12} sm={24} className="my-machines-header-left">
            <div>
              <h2 className="page-title">{t('pageTitle')}</h2>
              <h5 className="page-description">{t('pageRole')}</h5>
            </div>
          </Col>
          <Col xs={24} md={12} sm={24} className="my-machines-header-right">
            <BaseButton
              type="primary"
              className="base-yellow-btn addition-machine-btn"
              onClick={handleAddMachine}>
              {t('addMachineButton')}
            </BaseButton>
          </Col>
        </Row>
      </div>

      <Row>
        <Col xs={24} sm={24} lg={18} xl={12}>
          <MachineList />
        </Col>
      </Row>
    </div>
  );
};
